import { render } from "./orderDetail.vue?vue&type=template&id=6ff9d450&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"

import "./orderDetail.vue?vue&type=style&index=0&id=6ff9d450&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff9d450"]])

export default __exports__